// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width: 600px){.section[data-v-1c56c4da]{min-height:0}}@media(max-width: 599px){.text-h4[data-v-1c56c4da]{font-size:2.5rem !important}}@media(max-width: 410px){.text-h4[data-v-1c56c4da]{font-size:2.125rem !important}}@media(max-width: 349px){.text-h4[data-v-1c56c4da]{font-size:1.75rem !important;line-height:2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
